import { ElementRef, TemplateRef } from "@angular/core";

export interface FuseConfig {
    colorTheme?: string;
    preventScrollTop?: boolean;
    customScrollbars?: boolean;
    workingDomain?: string,
    layout?: {
        style?: string,
        width?: 'fullwidth' | 'boxed',
        zoomControl?: Boolean,
        navbar?: {
            headerClass?: string,
            hideMenuIcon?: boolean,
            primaryBackground?: string,
            secondaryBackground?: string,
            background?: string,
            hidden?: boolean,
            folded?: boolean,
            userNameShow?: boolean,
            profileImageSpinner?: {
                showSpinner: boolean;
                spinnerTemplate: any;
            };
            designationShow?: boolean, // do not use it, we will remove it in close future.
            designationText?: string,
            position?: 'left' | 'right' | 'top',
            variant?: string,
            dynamicVarientComponent?: any,
            laftNavigationTopLogo?: string,
            navbarTop?: string,
            userProfileDefaultImage?: string,
            hideHeader?: boolean,
            headerTemplate?: ElementRef | TemplateRef<any>,
            topMenu?: {
                showMyAccount?: boolean,
                showAbout?: boolean,
                showMemory?: boolean,
                showLogout?: boolean,
                logoutIcon?: string,
                customMenuComponent?:any,
                newMenuList?: { text: string, icon: string, callEvent?: object }[]
            },
            bottomMenu?: {
                showfooterNav?: boolean,
                footerNav?: any
            }
        },
        topBarUserMenu?: {
            hidden?: boolean,
            menus?: any
        },
        banner?:{
            hidden?: boolean,
            position?: 'above',
        }
        toolbar?: {
            logo?: string,
            customBackgroundColor?: boolean,
            background?: string,
            hidden?: boolean,
            position?: 'above' | 'above-static' | 'above-fixed' | 'below' | 'below-static' | 'below-fixed',
            component?: {
                shortcuts?: boolean,
                search?: boolean,
                userInfo?: boolean,
                userMenu?: {
                    showProfile?: boolean,
                    clickOnProfileEvent?: object
                    showMail?: boolean
                },
                sudebar?: boolean,
                rightLogo?: string,
                languageMenu?: {
                    show?: boolean,
                    showLearnMore?: boolean,
                    showFlag?: boolean,
                    languageList?: { id?: string, title?: string, flag?: string }[]
                }
            },
            breadcrumb?: boolean
        }
        footer?: {
            customBackgroundColor?: boolean,
            background?: string,
            hidden?: boolean,
            position?: 'above' | 'above-static' | 'above-fixed' | 'below' | 'below-static' | 'below-fixed'
        },
        sidepanel?: {
            hidden?: boolean,
            position?: 'left' | 'right',
            folded?: boolean,
            foldedWidth?: number,
            foldedAutoTriggerOnHover?: boolean,
            isOverlay?:boolean
        },
        quickpanel?: {
            hidden?: boolean,
            invisibleOverlay?: boolean
        },
        breadcrumb?: boolean,
        floatingChatPanelConfig?: Object,//as like 'admin': {showChatPanel: true,onlyNotification: true}
        notificationQueryPayload?: {
            ResponseKeys: [
                'MessagingThreadNotification'
            ],
            ResponseKeyFilterOperator: 'NotIn',
            OnlyUnread: false,
            OrderByCreatedDate: 1,
            ReturnCount: true,
            PageNumber: 1,
            PageSize: 100
        },
        onlyMessageQueryPayload?: {
            ResponseKeys: [
                'MessagingThreadNotification'
            ],
            ResponseKeyFilterOperator: 'In',
            OnlyUnread: true,
            OrderByCreatedDate: 1,
            ReturnCount: true,
            PageNumber: 1,
            PageSize: 100
        },
        progressbar?: {
            theme: string
        }
    },
    app?: {
        login?: {
            loginformTopLogo?: string
        }
    }
}
